module.exports = __webpack_public_path__ + "media/tick.png";